import { render } from "./QAView.vue?vue&type=template&id=d1c2a0f4&scoped=true&ts=true"
import script from "./QAView.vue?vue&type=script&lang=ts"
export * from "./QAView.vue?vue&type=script&lang=ts"

import "./QAView.vue?vue&type=style&index=0&id=d1c2a0f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c2a0f4"]])

export default __exports__